import script from "./servicepopup.vue?vue&type=script&setup=true&lang=js"
export * from "./servicepopup.vue?vue&type=script&setup=true&lang=js"

import "./servicepopup.vue?vue&type=style&index=0&id=b63d8dda&lang=scss"
import "./servicepopup.vue?vue&type=style&index=1&id=b63d8dda&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b63d8dda"]])

export default __exports__